export { MorphemeInfoPanelDictionarySimilarSection } from "#morpheme-info-panel-dictionary-similar-section";
export {
  useMorphemeInfoPanelDictionarySimilarSectionGate,
  type MorphemeInfoPanelDictionarySimilarSectionGate,
} from "#use-morpheme-info-panel-dictionary-similar-section-gate";
